// extracted by mini-css-extract-plugin
export default {"profileBackground":"Z_mKgj","tabsOuter":"rEPtPN","contentLayout":"sN3ysj"};